import React from 'react';
import { StyleProp, StyleSheet, View, ViewStyle } from 'react-native';
import { Edge, SafeAreaProvider, SafeAreaView } from 'react-native-safe-area-context';

import { ds } from '@/components/lib/design.system';

export type ScreenProps = {
    children: (React.JSX.Element | null)[] | React.JSX.Element;
    unsafe?: boolean | undefined | null;
    edges?: Edge[];
    style?: StyleProp<ViewStyle>;
};

export const Screen = ({ children, unsafe, edges = ['left', 'right', 'top'], style }: ScreenProps) => {
    if (unsafe) {
        return <View style={styles.root}>{children}</View>;
    }

    return (
        <SafeAreaView edges={edges} style={[styles.root, style]}>
            {children}
        </SafeAreaView>
    );
};

type SheetScreenProps = Omit<ScreenProps, 'unsafe'>;

// sheet screens need the correct inset on first mount, without any flickers
// so we need both the provider and the native view
// TODO: investigate if both types of screen can be merged into one component
// does adding safe area view to every screen affect our screens?
export const SheetScreen = ({ children, edges = ['left', 'right', 'top'], style }: SheetScreenProps) => {
    return (
        <SafeAreaProvider style={styles.provider}>
            <SafeAreaView edges={edges} style={[styles.root, style]}>
                {children}
            </SafeAreaView>
        </SafeAreaProvider>
    );
};

const styles = StyleSheet.create({
    provider: {
        flex: 1,
    },
    root: {
        backgroundColor: ds.colorValue.background.neutral.base,
        height: '100%',
        flexDirection: 'column',
    },
});
